module.exports = __webpack_public_path__ + "img/logo1.045713e7.webp";